import { createMuiTheme, colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#F4F6F8',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: colors.orange[500]
    },
    default: {
      main: colors.grey[500]
    },
    secondary: {
      main: colors.red[500]
    },
    success: {
      main: colors.green[500]
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600],
      active: colors.orange[900]
    }
  },
  shadows,
  typography
});

export default theme;
